import { render, staticRenderFns } from "./SoftwareCount.vue?vue&type=template&id=afeda468&scoped=true"
import script from "./SoftwareCount.vue?vue&type=script&lang=js"
export * from "./SoftwareCount.vue?vue&type=script&lang=js"
import style0 from "./SoftwareCount.vue?vue&type=style&index=0&id=afeda468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeda468",
  null
  
)

export default component.exports